import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
    paddingTop: theme.spacing(1.5),
    marginBottom: theme.spacing(-4),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: theme.spacing(42.875),
    overflow: 'auto',
    paddingRight: theme.spacing(2),
    '&::-webkit-scrollbar-track': {
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: theme.spacing(1),
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  recipientName: {
    color: theme.palette.labraText.tertiary,
    maxWidth: '40%',
  },
  recipientNameWithoutTitle: {
    width: '90%',
  },
  lastRowItem: {
    paddingBottom: `${theme.spacing(4)} !important`,
  },
  recipientTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  recipientTitleWrapper: {
    display: 'flex',
    width: '95%',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  recipientTitleName: {
    fontSize: '16px',
    lineHeight: theme.spacing(3),
    width: '40%',
    color: theme.palette.labraText.secondaryDescription,
  },
  rowItem: {
    padding: theme.spacing(1.5, 0),
  },
  rightSection: {
    padding: `${theme.spacing(2, 3)}`,
  },
  editActionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  disabledEdit: {
    opacity: '39%',
  },
}))
